import { makeRule } from '@core/utils/rule.js'

export let formRules = {
  whitelisttags: [
    {...makeRule('请选择白名单标签', 'array')},
  ],
  task_hint_text: [
    {...makeRule('请输入新手任务跳转文案', 'string')},
  ],
  taskid: [
    {...makeRule('请选择新手跳转任务', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/intelligent-customer-service/intelligent-customer-service.rules.js